
// 如果本地有用户信息缓存，就从本地拿
let userInfo = null;
try {
    userInfo = JSON.parse(localStorage.userInfo);
} catch (e) {
    userInfo = null;
}

/**
 * 使用方式，比如要获取username，就在页面上this.$store.state.user.username
 */
export default {
    namespaced: true, //开启命名空间
    state: () => ({
        id: '1',
        username: '测试的用户名',
        isBannerShow:true,
        isLocationAddress:false,
        openid: localStorage.openid,
        ...userInfo,
    }),
    mutations: {
        set(state, data) {
            for (const x in state) state[x] = data[x];
        },
        setUserName(state, n) {
            state.username = n;
        },
        setIsBannerShow(state, n) {
            state.isBannerShow = n;
        },
        setIsLocationAddress(state,n) {
            state.isLocationAddress = n;
        }
    },
    actions: {},
    getters: {}
}
